import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { FormModal } from 'basic-components';

import Prism from 'prismjs';
import Editor from 'react-simple-code-editor';

import './TextAreaModal.scss';

const EMPTY_FUN = () => {}
const ctrlKey = 17, rightCmdKey = 93, leftCmdKey = 91, sKey = 83, yKey = 89

const TextAreaModal = ({ close, onSubmit, defaultValue = "", optionalText, disabled }) => {
  const [ctrlDown, setCtrlDown] = useState(false),
        [content, setContent] = useState(defaultValue),
        onChange = useCallback(content => !disabled && setContent(content), [disabled]),
        higlightLocal = useCallback(code => Prism.highlight(code, Prism.languages.latex), []),
        codeEditor = useRef(),
        onKeyDown = useCallback(e => {
          (e.keyCode === ctrlKey || e.keyCode === leftCmdKey || e.keyCode === rightCmdKey) && setCtrlDown(true)
          if(ctrlDown && e.keyCode === sKey) {
            e.preventDefault()
            onSubmit()
          }
          if(ctrlDown && e.keyCode === yKey) {
            e.preventDefault()
            codeEditor?.current?._redoEdit()
          }
        }, [ctrlDown, onSubmit, codeEditor]),
        onKeyUp = useCallback(e => (e.keyCode === ctrlKey || e.keyCode === leftCmdKey || e.keyCode === rightCmdKey) && setCtrlDown(false), []),
        onSubmitLocal = useCallback(() => onSubmit(content), [content, onSubmit]),
        clearCtrl = useCallback(() => setCtrlDown(false), []),
        submitProps = useMemo(() => ({
          type: "button", // we need to prevent default submit to not sumbit underlaying autopipeline form
          onClick: () => {
            onSubmitLocal()
            close()
          },
        }),[close, onSubmitLocal])

  useEffect(() => {
    Prism.highlightAll()
  }, [])

  return (
    <FormModal
        className="data-science__pipeline-creator__body__options__resolver__header__ng-text-area"
        onBlur={clearCtrl}
        onClose={close}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onSubmit={EMPTY_FUN}
        open
        optionalText={optionalText}
        size="large"// we still override this in scss
        sizeWidth="large" // we still override this scss
        submitProps={submitProps}
        title="Edit text"
    >
      <Editor
          highlight={higlightLocal}
          onValueChange={onChange}
          padding={16}
          ref={codeEditor}
          textareaClassName="data-science__pipeline-creator__body__options__resolver__header__ng-text-area__text-area"
          value={content}
      />
    </FormModal>
  )
}

TextAreaModal.propTypes = {
  close: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  optionalText: PropTypes.string.isRequired,
}

export default memo(TextAreaModal);